import { render, staticRenderFns } from "./TiptapModV2.vue?vue&type=template&id=18aa249b&scoped=true"
import script from "./TiptapModV2.vue?vue&type=script&lang=js"
export * from "./TiptapModV2.vue?vue&type=script&lang=js"
import style0 from "./TiptapModV2.vue?vue&type=style&index=0&id=18aa249b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa249b",
  null
  
)

export default component.exports